
import { Component, OnInit, Injector } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AcessoService } from 'src/app/services/bas/acesso.service';
import { AbstractIdbaComponentComponent } from '../abstract-idba-component/abstract-idba-component.component';
import { CustomSnackBarService } from '../custom-snack-bar/custom-snack-bar.service';

@Component({
  selector: 'app-run-modal',
  templateUrl: './run-modal.component.html',
  styleUrls: ['./run-modal.component.scss']
})
export class RunModalComponent  extends AbstractIdbaComponentComponent implements OnInit {

  dialogRef: MatDialogRef<RunModalComponent>;

  constructor(
    private injector: Injector,
    snackBar: CustomSnackBarService,
    private formBuilder: UntypedFormBuilder,
    authService: AuthService,
    acessoService: AcessoService,
    private router: Router,
  ) {
		super(
			snackBar,
			authService,
			acessoService);

      this.dialogRef = this.injector.get(MatDialogRef);  
  }

  override ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit() {
		this.populateForm();
	}

  private createForm() {
    this.form = this.formBuilder.group({
      programa: [{ id: 0 },],
    });
  }

  populateForm() {
    this.acessoService.modelField['programa'].id = this.form.controls['programa'].value.id;
		this.acessoService.customListAll(undefined, this.form, 'programa', 'pi-consulta-permissao-usuario', { rowid: this.authService.getLoggedUserRowid() });
	}

	closeModal() {
		if (this.form.valid) {
			const obj = this.form.getRawValue();
			let registro = obj;

      this.router.navigate([registro.programa.siglaModulo.toLowerCase(),registro.programa.nomePrograma.toLowerCase()]);

      this.dialogRef.close();
		} else {
			this.showMessage('Campos obrigatórios não foram preenchidos.', 'Error');
		}
	}
}
